import { useEffect, useMemo } from 'react';

import {
  adminWorkshiftDetails,
  getLongTermContractAttributes,
  resetLongTermContractAttributes,
} from '@pharmaplan/common';

import useUpdateContract from '../LongTermContract/useUpdateContract';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';
import useGetItems from '../useGetItems';

const useFormatShiftDetails = () => {
  const dispatch = useAppDispatch();

  const currentWorkshift = useAppSelector(adminWorkshiftDetails);
  const { longTermShiftContract, logoId } = currentWorkshift ?? {};
  const { startDate: contractStart, endDate: contractEnd } = longTermShiftContract ?? {};

  const { getImage } = useGetItems();
  const logoImage = getImage(logoId);

  const { setAttributes } = useUpdateContract();

  const longTermAttributes = useAppSelector(getLongTermContractAttributes);
  const { shiftContractAttributes } = longTermAttributes ?? {};

  const requests = useMemo(() =>
    shiftContractAttributes.map(({ startDate, endDate }) =>
      ({
        startDate,
        endDate,
      })), [shiftContractAttributes]);

  useEffect(() => {
    setAttributes(contractStart, contractEnd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkshift]);

  useEffect(
    () =>
      () => {
        dispatch(resetLongTermContractAttributes());
      },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return { details: { ...currentWorkshift, requests, logoImage } };
};

export default useFormatShiftDetails;
